/**
 * Счётчик комментариев (§5.2, тип «Счётчик»). Не редактируется: нажатие
 * открывает карточку бренда на вкладке «Комментарии».
 *
 * Счётчики «Категории» и «Пропущено» жили здесь же и убраны вместе с группой
 * «Прочее»: по ним ничего не делали, а место они занимали.
 */
import { IconComment } from '../../../../components/index.js'
import { tableTexts as t } from '../../texts.table.js'
import type { CellProps } from './CellBox.js'

export function CommentsCell({ row, actions }: CellProps) {
  if (row.kind !== 'brand') return null
  const count = row.brand.commentsCount
  return (
    <button
      type="button"
      className={count === 0 ? 'cell__count cell__count--zero' : 'cell__count'}
      aria-label={count === 0 ? t.hint.noComments : t.hint.commentsCount(count)}
      onMouseDown={(event) => event.stopPropagation()}
      onClick={(event) => { event.stopPropagation(); actions.openComments() }}
    >
      {count === 0
        ? <span className="cell__count-icon" aria-hidden="true"><IconComment size={16} /></span>
        : count}
    </button>
  )
}

/** §4.9 «Пропущено»: пустые поля зоны ответственности смотрящего. */
export function NaCell() {
  return <span aria-label={t.hint.naCell}>·</span>
}
